import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, EditIcon, ProfileIcon, Text } from '@mercai/clever'
import { CustomAccordion } from '@/components'

import { ProfileGeneralInformationProps } from './general-information.type'
import styles from './general-information.module.css'
import { checkIfGeneralInformationIsComplete } from '../../general.constants'

export const GeneralInformation = ({
  profile,
  onClickEditBuyer,
  onClickEditLegalRepresentative,
  onClickEditPaymentRepresentative,
}: ProfileGeneralInformationProps) => {
  const { t } = useTranslation('screenProfileShow')

  const [activeItems, setActiveItems] = useState(['general-information'])

  const isComplete = checkIfGeneralInformationIsComplete(profile)

  return (
    <div className={styles.core}>
      <CustomAccordion
        activeItems={activeItems}
        setActiveItems={setActiveItems}
        id="general-information"
        title={`1. ${t('generalViewGeneralInformationTitle')}`}
        isComplete={isComplete}
      >
        <div className={styles['info-block']}>
          <div className={styles.title}>
            <ProfileIcon className={styles.icon} />
            <Text variant="title-medium">
              {t('generalViewGeneralInformationBuyerInfoTitle')}
            </Text>
          </div>

          <div className={styles['info-row']}>
            <div className={styles['info-row-content']}>
              <Text className={styles['info-item']}>
                <strong>{t('generalViewGeneralInformationNameLabel')}:</strong>{' '}
                {profile?.name || profile?.companyName || '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewGeneralInformationEmailLabel')}:</strong>{' '}
                {profile?.email || '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewGeneralInformationPhoneLabel')}:</strong>{' '}
                {profile?.phone || '-'}
              </Text>
            </div>

            <Button
              variant="secondary"
              className={styles.edit}
              size="small"
              onClick={onClickEditBuyer}
            >
              <EditIcon />
            </Button>
          </div>
        </div>

        <div className={styles['info-block']}>
          <div className={styles.title}>
            <ProfileIcon className={styles.icon} />
            <Text variant="title-medium">
              {t('generalViewGeneralInformationLegalRepresentativeTitle')}
            </Text>
          </div>

          <div className={styles['info-row']}>
            <div className={styles['info-row-content']}>
              <Text className={styles['info-item']}>
                <strong>{t('generalViewGeneralInformationNameLabel')}:</strong>{' '}
                {profile?.legalRepresentative?.name || '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewGeneralInformationEmailLabel')}:</strong>{' '}
                {profile?.legalRepresentative?.email || '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewGeneralInformationPhoneLabel')}:</strong>{' '}
                {profile?.legalRepresentative?.phone || '-'}
              </Text>
            </div>

            <Button
              variant="secondary"
              className={styles.edit}
              size="small"
              onClick={onClickEditLegalRepresentative}
            >
              <EditIcon />
            </Button>
          </div>
        </div>

        <div className={styles['info-block']}>
          <div className={styles.title}>
            <ProfileIcon className={styles.icon} />
            <Text variant="title-medium">
              {t('generalViewGeneralInformationPaymentsRepresentativeTitle')}
            </Text>
          </div>

          <div className={styles['info-row']}>
            <div className={styles['info-row-content']}>
              <Text className={styles['info-item']}>
                <strong>{t('generalViewGeneralInformationNameLabel')}:</strong>{' '}
                {profile?.paymentsRepresentative?.name || '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewGeneralInformationEmailLabel')}:</strong>{' '}
                {profile?.paymentsRepresentative?.email || '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewGeneralInformationPhoneLabel')}:</strong>{' '}
                {profile?.paymentsRepresentative?.phone || '-'}
              </Text>
            </div>

            <Button
              variant="secondary"
              className={styles.edit}
              size="small"
              onClick={onClickEditPaymentRepresentative}
            >
              <EditIcon />
            </Button>
          </div>
        </div>
      </CustomAccordion>
    </div>
  )
}
